import { Heading } from "@chakra-ui/react";
import { useEffect, useState } from "react";
import api from "../services/api";
import { useParams } from "react-router-dom";
import ClientCreationForm from "../components/clientCreationForm";


export default function ClientC({ initData }) {

  const { guid } = useParams();

  const [initialData, setInitialData] = useState(null);

  useEffect(() => {
    const getData = async () => {
      try {
        const resp = await api.epGetOrganizationData(guid);
        if (resp.status === 200) {
          resp.data.price = 0;
          setInitialData(resp.data);
          initData(resp.data);
         
          
        }
      } catch (error) {
        console.log(error);
      }
    }
    getData();
  }, [guid]);

  return (
    <>
      <Heading as="h1" variant={"h1"}>יצירת לקוח</Heading>
      <ClientCreationForm initialData={initialData} />
    </>

  )
}